import inherited from 'mastodon/locales/id.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
